import { defineCustomElement, getAttribute, getBooleanAttribute, getFirstSlotElement, getIntegerAttribute, getReactEventHandler, isAttrEqual, isAttrTrue, NectaryElement, updateAttribute, updateBooleanAttribute } from '../utils';
const templateHTML = '<style>:host{display:inline-block}::slotted(*){display:block}</style><slot></slot>';
import { doFilesSatisfySize } from './utils';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-file-picker', class extends NectaryElement {
  #$input;
  #$targetSlot;
  #$target = null;
  #controller = null;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$input = document.createElement('input');
    this.#$input.type = 'file';
    this.#$targetSlot = shadowRoot.querySelector('slot');
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const options = {
      signal: this.#controller.signal
    };
    this.#$targetSlot.addEventListener('slotchange', this.#onTargetSlotChange, options);
    this.#$input.addEventListener('change', this.#onInputChange, options);
    this.addEventListener('-change', this.#onChangeReactHandler, options);
    this.addEventListener('-invalid', this.#onInvalidReactHandler, options);
    this.#onTargetSlotChange();
  }
  disconnectedCallback() {
    this.#controller.abort();
    this.#controller = null;
    this.#$target = null;
  }
  static get observedAttributes() {
    return ['accept', 'multiple'];
  }
  attributeChangedCallback(name, oldVal, newVal) {
    switch (name) {
      case 'multiple':
        {
          if (isAttrEqual(oldVal, newVal)) {
            return;
          }
          updateBooleanAttribute(this.#$input, 'multiple', isAttrTrue(newVal));
          break;
        }
      case 'accept':
        {
          updateAttribute(this.#$input, 'accept', newVal);
          break;
        }
    }
  }
  set multiple(isMultiple) {
    updateBooleanAttribute(this, 'multiple', isMultiple);
  }
  get multiple() {
    return getBooleanAttribute(this, 'multiple');
  }
  set accept(value) {
    updateAttribute(this, 'accept', value);
  }
  get accept() {
    return getAttribute(this, 'accept');
  }
  get size() {
    return getIntegerAttribute(this, 'size', null);
  }
  set size(value) {
    updateAttribute(this, 'size', value);
  }
  #onTargetSlotChange = () => {
    this.#$target?.removeEventListener('-click', this.#onTargetClick);
    this.#$target = getFirstSlotElement(this.#$targetSlot, true);
    this.#$target?.addEventListener('-click', this.#onTargetClick);
  };
  #onTargetClick = () => {
    this.#$input.click();
  };
  #onInputChange = () => {
    if (this.#$input.files === null) {
      return;
    }
    const files = Array.from(this.#$input.files);
    this.#$input.value = '';
    if (!doFilesSatisfySize(files, this.size)) {
      this.dispatchEvent(new CustomEvent('-invalid', {
        detail: 'size'
      }));
      return;
    }
    this.dispatchEvent(new CustomEvent('-change', {
      detail: files
    }));
  };
  #onChangeReactHandler = e => {
    getReactEventHandler(this, 'on-change')?.(e);
  };
  #onInvalidReactHandler = e => {
    getReactEventHandler(this, 'on-invalid')?.(e);
  };
});